<script>
    import {
      Card,
      CardBody,
    } from "sveltestrap";

</script>

<Card>
    <CardBody>
        <div class="mb-4 h1 card-title">Dataset Description</div>
        <div>
          
          <p class="card-text">
            This is training data for a classification model that predicts legal judgments from facts. The legal judgment of the data is applied as of 2022.10.15 (data may differ from the actual legal judgment due to subsequent amendments and deletions of the law). 
          </p>
        </div>
      </CardBody>
</Card>